import {Constant} from "./index";
import {STATE} from "../../Type";

export class Touch extends Constant {
  get type() {
    return "Touch";
  }

  get category() {
    return "Constant";
  }

  static getPrototypeBlocks() {
    return [new Touch({data: "touch", state: STATE.PROTOTYPE})];
  }
}
